import { getContentModeTab } from "Areas/Sidebar/Documents/redux/selectors";
import { connect } from "react-redux";
import ContentSwitcher from "./contentSwitcher";
const mapStateToProps = (state) => ({
    contentModeTab: getContentModeTab(state)
});
export default connect(mapStateToProps)(ContentSwitcher);
